/* Greenleaf — search answers questions too. 13 Oct 2026, Andrew's yes via the Coordinator.
 *
 * WHAT IT DOES. When a search matches a question ("resize", "how long", "lab grown", "cheaper in
 * hawaii", "ring size", "care"), the answer shows ABOVE the products: one short line and a link to the
 * guide it comes from. It shows in two places: the top of the results page (the empty
 * [data-answer-slot] in gl-collection, search only) and the top of the as-you-type list
 * (assets/gl-search.js asks `window.glAnswers.find(q)`). Products still show below, unchanged.
 *
 * WHERE THE WORDS COME FROM. Every answer line below is a sentence copied word for word from the
 * guide it links to (the guide's opening summary, or one of its question-and-answer pairs), and
 * tests/test_search_answers.py checks that against docs/guides/guides.json on every run, so a line
 * cannot drift from its guide or be invented here. To add one: find the sentence in the guide,
 * copy it, add the words people type. No prices, no durations, nothing the guide does not say.
 *
 * WHICH GUIDES. A guide that is not published has no link: the header writes the handles of the
 * published guides into #gl-live-guides, and an answer whose guide is not in that list is skipped.
 * So the two guides that are still drafts (vacation, diamond) start answering the moment they are
 * published, with nothing to change here.
 *
 * MATCHING. The typed words are lower-cased and stripped of punctuation ("lab-grown" is "lab grown").
 * A phrase matches when its words appear in that order as whole words. "a+b" means both a and b
 * appear anywhere. The FIRST entry that matches wins, so the order below is deliberate: "how long
 * resize" gets the resizing answer, not the custom-ring one. Two lists per entry (tightened 15 Oct 2026,
 * see weak() below): k = full phrases that answer anywhere in the query; w = bare topic words that answer
 * only when they are ALL the query says, with filler words and the entry's own context words x.
 *
 * STORE FACTS AND GIFTS (18 Oct 2026, Andrew via the Coordinator: "hours", "do you ship" and "return policy" are
 * answered with what the site already says, not a guide; gift and budget searches go to the gifts page or the
 * under-price collections). FACTS below works like ANSWERS but each line is copied word for word from a page or
 * template of the theme (tests/test_search_answers.py checks), and links to a page or policy, so it needs no guide
 * to be published. FACTS are tried first. The gift and budget card (giftCard) is not a list: it reads the words
 * "gift", "birthday" and the like, and a price after "under", "below" or "budget".
 *
 * Without this file, with the list missing, or on any error, nothing extra shows: the page is as it was.
 */
(function () {
  'use strict';

  /*DATA*/
  var ANSWERS = [
    { "g": "ring-resizing-before-your-flight-home", "t": "Ring resizing before your flight home",
      "a": "Most rings can be resized, but a ring that feels tight in Maui heat may fit at home, so check the size more than once before you change it for good.",
      "k": ["resize", "resized", "resizing", "ring size", "ring sizing", "sizing", "what size", "ring too tight", "ring too loose", "ring doesnt fit", "ring does not fit"],
      "w": [], "x": [] },
    { "g": "how-long-does-a-custom-ring-take", "t": "How long does a custom ring take?",
      "a": "It depends on the design, the stone and your date, so the timing is agreed with you before any work begins.",
      "k": ["how long does a custom", "how long do custom", "how long to make", "how long for a custom", "custom ring take", "custom ring timeline", "custom turnaround", "by a certain date"],
      "w": ["how long", "turnaround", "timeline", "how many weeks", "how quickly", "how fast"], "x": ["custom", "ring", "rings", "take", "takes", "made", "make"] },
    { "g": "is-jewelry-cheaper-in-hawaii", "t": "Is jewelry cheaper in Hawaii?",
      "a": "The tax is usually lower: Maui's general excise tax is 4.5%, and a store may pass on at most 4.712%, below the combined sales tax in most states visitors come from.",
      "k": ["cheaper in hawaii", "jewelry cheaper", "cheaper than", "hawaii tax", "sales tax", "excise tax", "tax free", "duty free"],
      "w": ["tax", "taxes", "cheaper", "excise"], "x": ["hawaii", "maui", "jewelry", "the"] },
    { "g": "how-much-does-a-custom-ring-cost-on-maui", "t": "How much does a custom ring cost on Maui?",
      "a": "A custom ring costs what goes into it: the center stone, the metal, any side stones and the work in the design.",
      "k": ["how much does a custom", "how much is a custom", "how much for a custom", "custom ring cost", "cost of a custom", "cost to make", "what does a custom ring cost"],
      "w": ["cost", "costs", "how much", "budget"], "x": ["custom", "ring", "rings", "engagement", "maui"] },
    { "g": "lab-or-natural-diamond", "t": "Lab-grown or natural diamond?",
      "a": "A laboratory-grown diamond is a real diamond with the same chemical, physical and optical properties as a natural one.",
      "k": ["lab grown", "labgrown", "lab created", "lab made", "lab diamond", "lab diamonds", "laboratory grown", "man made diamond", "synthetic diamond"],
      "w": [], "x": [] },
    { "g": "caring-for-jewelry-in-salt-water-and-sun", "t": "Caring for jewelry in salt water and sun",
      "a": "Take rings, pearls and opals off before the ocean, a pool or sunscreen, and rinse everything else in fresh water when you are done for the day.",
      "k": ["jewelry care", "caring for", "how to clean", "clean my", "salt water", "saltwater", "chlorine", "sunscreen", "swimming with", "wear in the ocean"],
      "w": ["care", "cleaning", "clean"], "x": ["pearl", "pearls", "gold", "diamond", "diamonds", "silver", "platinum", "emerald", "emeralds", "opal", "opals", "sapphire", "ruby", "tanzanite", "turquoise", "ring", "rings", "necklace", "bracelet", "earrings", "pendant", "how", "jewellery"] },
    { "g": "where-to-buy-an-engagement-ring-in-wailea", "t": "Where to buy an engagement ring in Wailea",
      "a": "Our store is in the Shops at Wailea, open daily from 10am to 9pm, and every engagement ring on our site is in the case there.",
      "k": ["where to buy", "where can i buy", "store hours", "opening hours", "where are you", "where is greenleaf"],
      "w": ["hours", "address", "location"], "x": ["store", "open", "opening", "wailea", "greenleaf", "where", "your"] },
    { "g": "getting-engaged-in-maui", "t": "Getting engaged in Maui: where, when and how to find the ring",
      "a": "You can propose on any Maui beach without a permit; aim to arrive 30 minutes before sunset, about 5:15pm in December and 6:40pm in July.",
      "k": ["permit", "haleakala", "proposal spots", "where to propose", "best time to propose"],
      "w": [], "x": [] },
    { "g": "proposal-on-maui-checklist", "t": "Proposal on Maui checklist",
      "a": "Before you leave home, choose two spots, book anything that needs a reservation and work out the ring size.",
      "k": ["proposal checklist", "how to propose", "propose in maui", "propose on maui", "proposal on maui"],
      "w": ["propose", "proposal", "proposing"], "x": ["maui", "checklist", "ideas", "how", "plan", "planning"] },
    { "g": "what-hawaiian-jewelry-designs-mean", "t": "What Hawaiian jewelry designs mean",
      "a": "The honu (sea turtle), the makau (fish hook), the koholā (humpback whale) and the maile vine come from old Hawaiian life and story.",
      "k": ["honu+mean", "honu+meaning", "turtle+meaning", "makau+mean", "makau+meaning", "fish hook+meaning", "plumeria+meaning", "hawaiian+meaning", "hawaiian+symbol", "hawaiian designs"],
      "w": [], "x": [] },
    { "g": "how-to-pick-a-ring-on-vacation", "t": "How to pick a ring on vacation",
      "a": "Try the ring on in person, size it with the heat in mind, get every detail in writing, and carry it home in your hand luggage.",
      "k": ["on vacation", "tsa", "carry on", "fly with", "flying with"],
      "w": ["vacation"], "x": ["ring", "rings", "buy", "buying", "pick", "picking", "how"] },
    { "g": "diamond-buying-guide", "t": "How to choose a diamond: the 4Cs in plain English",
      "a": "A diamond's quality comes down to four things, known as the 4Cs: color, clarity, cut and carat.",
      "k": ["4cs", "4 cs", "four cs", "how to choose a diamond", "diamond buying guide", "color grade", "clarity grade", "diamond color", "diamond clarity", "diamond carat"],
      "w": [], "x": [] }
  ];
  /*END*/

  /*FACTS*/
  var FACTS = [
    { "id": "hours", "l": "Plan a visit", "u": "/pages/visit",
      "a": "Open daily, 10am–9pm, at the Shops at Wailea.",
      "k": ["store hours", "opening hours", "business hours", "are you open", "open today", "open daily", "what time", "when are you open", "where are you", "where is greenleaf", "where are you located", "your address", "your location"],
      "w": ["hours", "address", "location"], "x": ["store", "open", "opening", "wailea", "greenleaf", "where", "your", "are", "you", "business"] },
    { "id": "shipping", "l": "Read the shipping policy", "u": "/policies/shipping-policy",
      "a": "Collect it at the counter, or we send it insured, wherever you are.",
      "k": ["do you ship", "ship to", "free shipping", "shipping cost", "shipping time", "how much is shipping", "do you deliver", "international shipping", "ship internationally"],
      "w": ["shipping", "ship", "delivery", "deliver", "shipped"], "x": ["do", "you", "free", "cost", "how", "much", "long", "does", "take", "internationally", "international", "mainland", "policy", "time", "times", "options", "rates"] },
    { "id": "returns", "l": "Read the return policy", "u": "/policies/refund-policy",
      "a": "Insured shipping, and 30 days to return it.",
      "k": ["return policy", "returns policy", "refund policy", "can i return", "money back", "exchange policy", "can i exchange"],
      "w": ["return", "returns", "refund", "refunds"], "x": ["policy", "your", "do", "you", "accept", "allow", "item", "ring", "piece"] }
  ];
  /*END FACTS*/

  var GIFT_LINE = "Picked by price, by person and by occasion. Every piece is in the case at the Shops at Wailea, so you can come in and try it on.";
  var GIFT_URL = "/pages/gifts", GIFT_LABEL = "See our gifts";
  var BUDGETS = [
    { "max": 1000, "u": "/collections/under-1000", "l": "Jewelry under $1,000" },
    { "max": 2500, "u": "/collections/under-2500", "l": "Jewelry under $2,500" }
  ];

  function norm(s) {
    return ' ' + String(s || '').toLowerCase().replace(/[^a-z0-9\u00c0-\u024f]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
  }

  // Words that may sit around a bare topic word without changing the question: "the cost", "my ring size".
  var STOP = ' the a an of is are my your do does i to for in on at it me can you what jewelry ';

  function hit(q, phrase) {
    var parts = phrase.split('+');
    for (var i = 0; i < parts.length; i++) {
      if (q.indexOf(norm(parts[i])) < 0) return false;
    }
    return true;
  }

  /* TIGHTENED 15 Oct 2026 (audit): a broad word ("how long", "cost", "care", "tax", "address") used to
     bring a guide answer above ANY search that held it, so "how long chain necklace" got the custom-ring
     timing. Now an entry answers when EITHER
       k: one of its own full phrases is in the query (anywhere: "custom ring cost", "lab grown"), or
       w: its bare topic words are ALL the query says, plus filler words (STOP) and the entry's own
          context words (x): "tax", "pearl care", "how long", "custom ring cost", but not "diamond cost",
          "care package" or "how long does shipping take".
     A search that is just a kind of piece ("ring", "emerald cut ring") never matches. */
  function weak(q, e) {
    if (!e.w || !e.w.length) return false;
    var rest = q, found = false;
    for (var i = 0; i < e.w.length; i++) {
      var p = norm(e.w[i]);
      if (rest.indexOf(p) > -1) { found = true; rest = rest.split(p).join(' '); }
    }
    if (!found) return false;
    var allow = STOP + ' ' + (e.x || []).join(' ') + ' ';
    var left = rest.split(' ').filter(Boolean);
    for (var j = 0; j < left.length; j++) {
      if (allow.indexOf(' ' + left[j] + ' ') < 0) return false;
    }
    return true;
  }

  function liveGuides() {
    var el = document.getElementById('gl-live-guides');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function root() {
    return (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* A gift or a budget in the words: "gift under 500", "birthday gift for wife", "under 1000", "gifts". Gift words
     send to the gifts page; a price after under/below/budget sends to the collection that covers it. Cheap-words
     with no number mean the lowest collection. "gift card" is left alone (a different thing). */
  function giftCard(raw) {
    var r = String(raw || '').toLowerCase().replace(/(\d),(\d{3})/g, '$1$2');
    if (/gift ?cards?|gift certificates?/.test(r)) return null;
    var gift = /\b(gifts?|presents?|birthday|christmas|valentines?|graduation|stocking stuffers?)\b/.test(r);
    var m = r.match(/\b(?:under|below|less than|up to|max|maximum|budget(?: of)?|within|around|about)\s*\$?\s*(\d+(?:\.\d+)?)\s*(k|grand)?\b/) || r.match(/\$\s*(\d+(?:\.\d+)?)\s*(k|grand)?\b/);
    var n = m ? parseFloat(m[1]) * (m[2] ? 1000 : 1) : null;
    var cheap = /\b(cheap|affordable|inexpensive)\b/.test(r);
    if (!gift && n === null && !cheap) return null;
    var pick = null;
    if (n !== null || cheap) {
      for (var i = 0; i < BUDGETS.length; i++) {
        if (cheap && n === null ? i === 0 : n <= BUDGETS[i].max) { pick = BUDGETS[i]; break; }
      }
    }
    if (!pick && !gift) return null;
    return { a: GIFT_LINE, t: pick ? pick.l : GIFT_LABEL, l: pick ? pick.l : GIFT_LABEL, url: root() + (pick ? pick.u : GIFT_URL).replace(/^\//, '') };
  }

  /* find(query, live): the first answer whose words are in the query, or null. Gift and budget words first, then
     the store facts, then the guides: a guide answers only if published (`live` is a list of published guide
     handles; left out, it is read from the page). Every result has a (the line), t (a title), l (the link
     words) and url. */
  function find(query, live) {
    var q = norm(query);
    if (q.length < 3) return null;
    var g = giftCard(query);
    if (g) return g;
    var i, j, e, yes;
    for (i = 0; i < FACTS.length; i++) {
      e = FACTS[i];
      yes = weak(q, e);
      for (j = 0; !yes && j < e.k.length; j++) yes = hit(q, e.k[j]);
      if (yes) return { a: e.a, t: e.l, l: e.l, url: root() + e.u.replace(/^\//, '') };
    }
    var open = live || (typeof document !== 'undefined' ? liveGuides() : null);
    if (!open) return null;
    for (i = 0; i < ANSWERS.length; i++) {
      e = ANSWERS[i];
      if (open.indexOf(e.g) < 0) continue;
      yes = weak(q, e);
      for (j = 0; !yes && j < e.k.length; j++) yes = hit(q, e.k[j]);
      if (yes) return { a: e.a, t: e.t, l: 'Read the guide: ' + e.t, url: root() + 'blogs/guides/' + e.g };
    }
    return null;
  }

  var api = { find: find, data: ANSWERS, facts: FACTS, giftLine: GIFT_LINE };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  window.glAnswers = api;

  /* The results page: fill the empty slot above the grid. */
  function results() {
    var slot = document.querySelector('[data-answer-slot]');
    if (!slot) return;
    var q = new URLSearchParams(window.location.search).get('q');
    var h = q && find(q);
    if (!h) return;
    var p = document.createElement('p');
    p.className = 'sans__a';
    p.textContent = h.a;
    var a = document.createElement('a');
    a.className = 'sans__l';
    a.href = h.url;
    a.textContent = h.l;
    slot.className = 'sans';
    slot.setAttribute('role', 'note');
    slot.setAttribute('aria-label', 'An answer');
    slot.appendChild(p);
    slot.appendChild(a);
    slot.hidden = false;
  }
  if (document.readyState !== 'loading') results();
  else document.addEventListener('DOMContentLoaded', results);
})();
